export default __webpack_public_path__ + "static/media/coins.169f7f40.svg";